export enum GamesQueryKeys {
  Primary = '/games',
  BySlug = '/games/by-slug',
  ByProvider = '/games/by-provider',
  TopPayout = '/games/top-payout',
  RecentlyPlayed = '/games/recently-played',
  Tiles = '/games/tiles',
  Config = '/games/config',
  WinProbability = '/games/win-probability',
}
